export default __webpack_public_path__ + "static/m-banner-a381ea13b8ac44224d60480b8871f3cc.jpg";